import { HeaderTextBlock, P } from "@/components/Typography";
import { Button } from "@/components/Button";
import { MAILTO_SUPPORT, SUPPORT_MEETING_URL } from "@/utils/const";
import { Trans, useTranslation } from "react-i18next";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";

import datashipsLogo from "@/assets/svgs/dataships-logo.svg";
import backgroundImage from "@/assets/images/collect/generic-people.png";
import { useSearchParams } from "react-router-dom";

const CannotInstall = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const renderShopName = () => {
    if (!!searchParams.get("shop")) return ` (${searchParams.get("shop")})`;

    return "";
  };

  return (
    <div className="flex min-h-screen flex-row bg-secondary-dark text-white">
      <div className="ml-auto flex w-full justify-end px-20 py-30 text-white sm:min-h-screen sm:w-[55%] sm:px-[120px] sm:py-50">
        <div className="flex h-full max-w-[560px] flex-col gap-30 sm:gap-50">
          <div>
            <a href="https://dataships.io/" aria-label="Home">
              <img src={datashipsLogo} className="h-[27px] sm:h-[34px]" />
            </a>
          </div>

          <div className="flex flex-grow items-center">
            <div className="flex flex-col gap-30 sm:gap-50">
              <HeaderTextBlock
                featureTextIcon={faExclamationTriangle}
                featureText={t("publicScreens.cannotInstall.header.feature")}
                headingText={t("publicScreens.cannotInstall.header.heading")}
                headingTextColor="white"
                customHtmlPosition="bottom"
                customHtml={
                  <>
                    <P color="white" className="mb-10">
                      <Trans
                        i18nKey="publicScreens.cannotInstall.header.description"
                        values={{ shop: renderShopName() }}>
                        We noticed you already have our app installed on the
                        Shopify store you selected<b>shop</b>. To install on
                        another store, it\'s easy to add another Company to your
                        Dataships account, just log in and select "Add new
                        company" from the Company Switcher in the navigation
                        bar.
                      </Trans>
                    </P>
                    <P color="white">
                      <Trans i18nKey="publicScreens.cannotInstall.header.support">
                        If you need any help, please email
                        <Button
                          as="a"
                          href={MAILTO_SUPPORT}
                          target="_blank"
                          variant="white-link">
                          support@dataships.io
                        </Button>
                        or book a meeting with our Customer Success team.
                      </Trans>
                    </P>
                  </>
                }
              />

              <div className="flex flex-col gap-30 lg:flex-row">
                <Button as="link" to="/auth/login">
                  {t("publicScreens.cannotInstall.buttons.logIn")}
                </Button>
                <Button
                  as="a"
                  href={SUPPORT_MEETING_URL}
                  target="_blank"
                  variant="white-outline">
                  {t("publicScreens.cannotInstall.buttons.customerSuccess")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative hidden w-[45%] bg-white text-secondary sm:flex">
        <div className="absolute inset-0 bg-secondary-dark/40"></div>
        <img src={backgroundImage} className="object-cover" />
      </div>
    </div>
  );
};

export default CannotInstall;
